import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const BASE_URL      = "https://senutour.com/api";
const CLOUD_NAME    = "dhs2cu6vv";
const UPLOAD_PRESET = "senutour_unsigned";

const getToken = () => localStorage.getItem("token");
const getUser  = () => JSON.parse(localStorage.getItem("user") || "{}");

// ── Icônes SVG ──────────────────────────────────────────────────
const IcGrid    = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>;
const IcActivity= () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>;
const IcCalendar= () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IcHistory = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const IcStar    = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;
const IcUpload  = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg>;
const IcCheck   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>;
const IcX       = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcTrash   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>;
const IcEdit    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IcPhone   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.82 19a19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 3.09 4.18 2 2 0 0 1 5.09 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const IcUser    = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.8" strokeLinecap="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;

// ── Constantes ───────────────────────────────────────────────────
const TYPES_LOISIR  = ["Plage", "Culture", "Sport", "Nature", "Aventure", "Bien-être", "Gastronomie", "Nightlife"];
const DUREES        = ["1h", "2h", "3h", "Demi-journée", "Journée", "Week-end"];
const VILLES        = ["Dakar", "Diamniadio", "Saly", "Saint-Louis", "Ziguinchor", "Thiès", "Touba", "Kaolack"];

const STATUT_RESA = {
  confirmee:  { label: "Confirmée",  color: "#3D6B2E", bg: "rgba(61,107,46,0.10)" },
  en_attente: { label: "En attente", color: "#C4841A", bg: "rgba(196,132,26,0.10)" },
  annulee:    { label: "Annulée",    color: "#C4441A", bg: "rgba(196,68,26,0.10)" },
};

const ONGLETS = [
  { id: "dashboard",    label: "Vue générale",   Icon: IcGrid },
  { id: "activites",    label: "Mes activités",  Icon: IcActivity },
  { id: "reservations", label: "Réservations",   Icon: IcCalendar },
  { id: "historique",   label: "Historique",     Icon: IcHistory },
  { id: "avis",         label: "Avis clients",   Icon: IcStar },
];

const FORM_VIDE = {
  nom: "", description: "", type: "Plage", ville: "Dakar", adresse: "",
  prix: "", duree: "2h", disponible: true, telephoneContact: "",
};

const formatPrix = (p) => {
  if (!p || p === 0) return "Gratuit";
  return Number(p).toLocaleString("fr-FR") + " F";
};

// Styles statiques du formulaire — sortis du composant, ils ne changent
// jamais entre les rendus, donc autant les définir une seule fois ici.
const labelStyle = { display: "block", fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 };
const inputStyle = { width: "100%", boxSizing: "border-box", padding: "11px 14px", border: "1.5px solid #E8DCC8", borderRadius: 10, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, outline: "none", color: "#1C1008", background: "white" };

// ── Formulaire réutilisable ────────────────────────────────────
// IMPORTANT : ce composant est déclaré EN DEHORS de LoisirDashboard.
// Si on le déclarait à l'intérieur, React le recréerait à chaque frappe
// (puisque taper une lettre déclenche un re-render du dashboard via
// setForm/setEditForm), ce qui détruit et recrée les <input> du DOM à
// chaque caractère — c'est exactement ce qui causait la perte de focus
// et l'impression que le formulaire "bloquait" après chaque lettre.
const FormulaireActivite = ({ f, setF, ph, setPh, onSave, onCancel, saving: sv, titre, uploading, fileRef, onPhotoChange }) => (
  <div style={{ background: "white", borderRadius: 16, border: "1.5px solid #E8DCC8", padding: "32px", marginBottom: 28, boxShadow: "0 4px 20px rgba(28,16,8,0.08)" }}>
    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 20, fontWeight: 800, color: "#1C1008", marginBottom: 24 }}>{titre}</h3>

    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 20px" }}>
      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>Nom de l'activité *</label>
        <input value={f.nom} onChange={e => setF({ ...f, nom: e.target.value })} placeholder="Ex: Surf à Yoff" style={inputStyle} />
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>Adresse</label>
        <input value={f.adresse} onChange={e => setF({ ...f, adresse: e.target.value })} placeholder="Ex: Plage de Yoff, Dakar" style={inputStyle} />
      </div>
    </div>

    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0 16px" }}>
      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>Type *</label>
        <select value={f.type} onChange={e => setF({ ...f, type: e.target.value })} style={inputStyle}>
          {TYPES_LOISIR.map(t => <option key={t}>{t}</option>)}
        </select>
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>Ville *</label>
        <select value={f.ville} onChange={e => setF({ ...f, ville: e.target.value })} style={inputStyle}>
          {VILLES.map(v => <option key={v}>{v}</option>)}
        </select>
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>Durée</label>
        <select value={f.duree} onChange={e => setF({ ...f, duree: e.target.value })} style={inputStyle}>
          {DUREES.map(d => <option key={d}>{d}</option>)}
        </select>
      </div>
    </div>

    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0 16px" }}>
      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>Prix (F CFA) — laisser vide si gratuit</label>
        <input type="number" value={f.prix} onChange={e => setF({ ...f, prix: e.target.value })} placeholder="Ex: 15000" style={inputStyle} />
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>Disponible</label>
        <select value={f.disponible ? "oui" : "non"} onChange={e => setF({ ...f, disponible: e.target.value === "oui" })} style={inputStyle}>
          <option value="oui">Oui</option>
          <option value="non">Non</option>
        </select>
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>WhatsApp / Téléphone de contact *</label>
        <input value={f.telephoneContact} onChange={e => setF({ ...f, telephoneContact: e.target.value })} placeholder="+221 77 000 00 00" style={inputStyle} />
      </div>
    </div>

    <div style={{ marginBottom: 20 }}>
      <label style={labelStyle}>Description</label>
      <textarea value={f.description} onChange={e => setF({ ...f, description: e.target.value })}
        placeholder="Décrivez l'activité, ce qui est inclus, le niveau requis…"
        rows={4} style={{ ...inputStyle, resize: "vertical", lineHeight: 1.6 }} />
    </div>

    <div style={{ marginBottom: 24 }}>
      <label style={labelStyle}>Photos</label>
      <div onClick={() => fileRef.current?.click()}
        style={{ border: "2px dashed #E8DCC8", borderRadius: 12, padding: "28px", textAlign: "center", cursor: "pointer" }}>
        <input ref={fileRef} type="file" multiple accept="image/*" onChange={onPhotoChange} style={{ display: "none" }} />
        {uploading ? <p style={{ color: "#7A5A3A", margin: 0, fontSize: 14 }}>Chargement…</p> : (
          <><IcUpload /><p style={{ color: "#7A5A3A", margin: "8px 0 4px", fontSize: 14, fontWeight: 600 }}>Cliquez pour ajouter des photos</p></>
        )}
      </div>
      {ph.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 12 }}>
          {ph.map((url, i) => (
            <div key={i} style={{ position: "relative", width: 80, height: 80, borderRadius: 8, overflow: "hidden" }}>
              <img src={url} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              <button onClick={() => setPh(prev => prev.filter(p => p !== url))}
                style={{ position: "absolute", top: 4, right: 4, background: "rgba(196,68,26,0.85)", border: "none", borderRadius: "50%", width: 20, height: 20, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "white" }}>
                <IcX />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>

    <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
      <button onClick={onCancel} style={{ background: "white", border: "1.5px solid #E8DCC8", borderRadius: 10, padding: "11px 20px", fontSize: 14, fontWeight: 600, color: "#7A5A3A", cursor: "pointer" }}>
        Annuler
      </button>
      <button onClick={onSave} disabled={sv}
        style={{ background: "#C4441A", border: "none", borderRadius: 10, padding: "11px 28px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, color: "white", cursor: "pointer", opacity: sv ? 0.7 : 1 }}>
        {sv ? "Enregistrement…" : "Enregistrer"}
      </button>
    </div>
  </div>
);

export default function LoisirDashboard() {
  const navigate  = useNavigate();
  const user      = getUser();
  const fileRef   = useRef();
  const fileEditRef = useRef();

  const [onglet, setOnglet]             = useState("dashboard");
  const [loisirs, setLoisirs]           = useState([]);
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading]           = useState(true);
  const [filtreStatut, setFiltreStatut] = useState("tous");

  // ── Formulaire ajout ─────────────────────────────────────────
  const [showForm, setShowForm]   = useState(false);
  const [form, setForm]           = useState(FORM_VIDE);
  const [photos, setPhotos]       = useState([]);
  const [uploading, setUploading] = useState(false);
  const [saving, setSaving]       = useState(false);

  // ── Formulaire édition ───────────────────────────────────────
  const [editId, setEditId]         = useState(null);
  const [editForm, setEditForm]     = useState(FORM_VIDE);
  const [editPhotos, setEditPhotos] = useState([]);
  const [editSaving, setEditSaving] = useState(false);

  // ── Chargement ───────────────────────────────────────────────
  useEffect(() => {
    const charger = async () => {
      try {
        const [resL, resR] = await Promise.all([
          fetch(`${BASE_URL}/loisirs/mes-loisirs`, { headers: { Authorization: `Bearer ${getToken()}` } }),
        Promise.resolve({ ok: true, json: async () => [] }),
        ]);
        const l = await resL.json();
        const r = await resR.json();
        setLoisirs(Array.isArray(l) ? l : []);
        setReservations(Array.isArray(r) ? r : []);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    charger();
  }, []);

  // ── Upload photos ────────────────────────────────────────────
  const uploadPhotos = async (files, setPhotosState) => {
    const urls = await Promise.all(files.map(async (file) => {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("upload_preset", UPLOAD_PRESET);
      const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, { method: "POST", body: fd });
      const data = await res.json();
      return data.secure_url;
    }));
    setPhotosState(prev => [...prev, ...urls]);
  };

  const handlePhotos = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setUploading(true);
    try { await uploadPhotos(files, setPhotos); }
    catch { alert("Erreur upload photo."); }
    finally { setUploading(false); }
  };

  const handleEditPhotos = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setUploading(true);
    try { await uploadPhotos(files, setEditPhotos); }
    catch { alert("Erreur upload photo."); }
    finally { setUploading(false); }
  };

  // ── Ajouter activité ─────────────────────────────────────────
  const ajouterLoisir = async () => {
    if (!form.nom || !form.type || !form.ville) { alert("Nom, type et ville obligatoires."); return; }
    if (!form.telephoneContact) { alert("Le numéro WhatsApp/téléphone de contact est obligatoire — c'est lui qui permet aux clients de vous joindre."); return; }
    setSaving(true);
    try {
      const res = await fetch(`${BASE_URL}/loisirs`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
        body: JSON.stringify({
          ...form,
          prix: parseInt(form.prix) || 0,
          images: photos,
          disponible: true,
        }),
      });
      const data = await res.json();
      if (res.ok) {
        setLoisirs(prev => [data.loisir, ...prev]);
        setShowForm(false); setForm(FORM_VIDE); setPhotos([]);
      } else alert(data.message || "Erreur.");
    } catch { alert("Erreur serveur."); }
    finally { setSaving(false); }
  };

  // ── Modifier activité ────────────────────────────────────────
  const ouvrirEdit = (l) => {
    setEditId(l.id);
    setEditForm({ nom: l.nom, description: l.description || "", type: l.type, ville: l.ville, adresse: l.adresse || "", prix: l.prix || "", duree: l.duree || "2h", disponible: l.disponible, telephoneContact: l.telephoneContact || user.telephone || "" });
    setEditPhotos(l.images || []);
  };

  const sauvegarderEdit = async () => {
    setEditSaving(true);
    try {
      const res = await fetch(`${BASE_URL}/loisirs/${editId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
        body: JSON.stringify({ ...editForm, prix: parseInt(editForm.prix) || 0, images: editPhotos }),
      });
      const data = await res.json();
      if (res.ok) {
        setLoisirs(prev => prev.map(l => l.id === editId ? { ...l, ...editForm, prix: parseInt(editForm.prix) || 0, images: editPhotos } : l));
        setEditId(null);
      } else alert(data.message || "Erreur.");
    } catch { alert("Erreur serveur."); }
    finally { setEditSaving(false); }
  };

  // ── Supprimer activité ───────────────────────────────────────
  const supprimerLoisir = async (id) => {
    if (!window.confirm("Supprimer cette activité ?")) return;
    await fetch(`${BASE_URL}/loisirs/${id}`, { method: "DELETE", headers: { Authorization: `Bearer ${getToken()}` } });
    setLoisirs(prev => prev.filter(l => l.id !== id));
  };

  // ── Actions réservations ─────────────────────────────────────
  const confirmerResa = async (id) => {
    await fetch(`${BASE_URL}/reservations-loisir/${id}/confirmer`, { method: "PATCH", headers: { Authorization: `Bearer ${getToken()}` } });
    setReservations(prev => prev.map(r => r.id === id ? { ...r, statut: "confirmee" } : r));
  };

  const annulerResa = async (id) => {
    await fetch(`${BASE_URL}/reservations-loisir/${id}/annuler`, { method: "PATCH", headers: { Authorization: `Bearer ${getToken()}` } });
    setReservations(prev => prev.map(r => r.id === id ? { ...r, statut: "annulee" } : r));
  };

  // ── Dérivés ──────────────────────────────────────────────────
  const resasAttente  = reservations.filter(r => r.statut === "en_attente");
  const resasFiltrees = filtreStatut === "tous" ? reservations : reservations.filter(r => r.statut === filtreStatut);
  const totalRevenus  = reservations.filter(r => r.statut === "confirmee").reduce((s, r) => s + (r.total || 0), 0);

  if (loading) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#FAF5EC", fontFamily: "'Space Grotesk',sans-serif", color: "#7A5A3A" }}>
      Chargement…
    </div>
  );

  return (
    <>
      <Navbar />
      <div style={{ fontFamily: "'Space Grotesk',sans-serif", background: "#FAF5EC", minHeight: "100vh", color: "#1C1008" }}>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
          .onglet-btn { transition: all .2s; cursor: pointer; border: none; background: none; }
          .onglet-btn:hover { color: #C4441A !important; }
          .btn-primary { background: #C4441A; transition: background .2s; border: none; cursor: pointer; }
          .btn-primary:hover { background: #A03614; }
          .btn-success { background: #3D6B2E; transition: background .2s; border: none; cursor: pointer; }
          .btn-success:hover { background: #2D5220; }
          .card-hover { transition: all .2s; }
          .card-hover:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(28,16,8,0.10) !important; }
          .row-hover:hover { background: rgba(196,68,26,0.02) !important; }
          @media (max-width: 767px) { .stats-grid { grid-template-columns: 1fr 1fr !important; } .activites-grid { grid-template-columns: 1fr !important; } }
        `}</style>

        {/* ── HEADER ── */}
        <div style={{ background: "linear-gradient(135deg,#1C1008 0%,#2D1A08 100%)", padding: "48px 5% 36px", position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(circle,rgba(196,68,26,.07) 1px,transparent 1px)", backgroundSize: "28px 28px" }} />
          <div style={{ maxWidth: 1100, margin: "0 auto", position: "relative", zIndex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
                <div style={{ width: 64, height: 64, borderRadius: "50%", background: "linear-gradient(135deg,#C4441A,#E8834A)", display: "flex", alignItems: "center", justifyContent: "center", border: "3px solid rgba(255,255,255,0.2)", flexShrink: 0, overflow: "hidden" }}>
                  {localStorage.getItem("sunutour_photo")
                    ? <img src={localStorage.getItem("sunutour_photo")} style={{ width: "100%", height: "100%", objectFit: "cover" }} alt="profil" />
                    : <IcUser />}
                </div>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#C4441A", textTransform: "uppercase", letterSpacing: 2, marginBottom: 4 }}>Dashboard Loisirs & Activités · JOJ 2026</div>
                  <h1 style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 800, color: "white", margin: 0 }}>
                    {user.prenom} {user.nom}
                  </h1>
                  <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", marginTop: 3 }}>
                    {loisirs.length} activité{loisirs.length !== 1 ? "s" : ""} · {resasAttente.length} réservation{resasAttente.length !== 1 ? "s" : ""} en attente
                  </div>
                </div>
              </div>
              <button className="btn-primary" onClick={() => { setOnglet("activites"); setShowForm(true); }}
                style={{ color: "white", borderRadius: 10, padding: "12px 22px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, display: "flex", alignItems: "center", gap: 8, boxShadow: "0 8px 20px rgba(196,68,26,0.35)" }}>
                + Ajouter une activité
              </button>
            </div>
          </div>
        </div>

        {/* ── ONGLETS ── */}
        <div style={{ background: "white", borderBottom: "1.5px solid #E8DCC8", padding: "0 5%", overflowX: "auto" }}>
          <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", gap: 4, minWidth: "max-content" }}>
            {ONGLETS.map(o => (
              <button key={o.id} className="onglet-btn" onClick={() => setOnglet(o.id)}
                style={{ padding: "16px 18px", fontSize: 13, fontWeight: 600, color: onglet === o.id ? "#C4441A" : "#7A5A3A", borderBottom: onglet === o.id ? "2px solid #C4441A" : "2px solid transparent", marginBottom: -1, display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}>
                <o.Icon /> {o.label}
                {o.id === "reservations" && resasAttente.length > 0 && (
                  <span style={{ background: "#C4441A", color: "white", borderRadius: "50%", width: 18, height: 18, fontSize: 10, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>{resasAttente.length}</span>
                )}
              </button>
            ))}
          </div>
        </div>

        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "36px 5% 60px" }}>

          {/* ══ VUE GÉNÉRALE ══ */}
          {onglet === "dashboard" && (
            <>
              <div className="stats-grid" style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 16, marginBottom: 32 }}>
                {[
                  { label: "Activités",          value: loisirs.length,                               color: "#C4441A" },
                  { label: "En attente",          value: resasAttente.length,                          color: "#C4841A" },
                  { label: "Réservations totales",value: reservations.length,                          color: "#3D6B2E" },
                  { label: "Revenus confirmés",   value: totalRevenus.toLocaleString() + " F",         color: "#3D6B2E" },
                ].map((s, i) => (
                  <div key={i} className="card-hover" style={{ background: "white", borderRadius: 14, padding: "22px", border: "1.5px solid #E8DCC8", boxShadow: "0 2px 12px rgba(28,16,8,0.06)" }}>
                    <div style={{ fontFamily: "'Fraunces',serif", fontSize: 28, fontWeight: 800, color: s.color }}>{s.value}</div>
                    <div style={{ fontSize: 12, color: "#7A5A3A", marginTop: 6, fontWeight: 600 }}>{s.label}</div>
                  </div>
                ))}
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
                {/* Mes activités */}
                <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                  <div style={{ padding: "18px 24px", borderBottom: "1.5px solid #E8DCC8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008", margin: 0 }}>Mes activités</h3>
                    <button onClick={() => setOnglet("activites")} style={{ fontSize: 12, color: "#C4441A", fontWeight: 600, background: "none", border: "none", cursor: "pointer" }}>Voir tout →</button>
                  </div>
                  {loisirs.length === 0
                    ? <div style={{ padding: 32, textAlign: "center", color: "#7A5A3A", fontSize: 13 }}>Aucune activité — ajoutez la vôtre !</div>
                    : loisirs.slice(0, 4).map((l, i, arr) => (
                      <div key={l.id} style={{ padding: "14px 24px", borderBottom: i < arr.length - 1 ? "1px solid #F2E4C8" : "none", display: "flex", alignItems: "center", gap: 12 }}>
                        <div style={{ width: 40, height: 40, borderRadius: 8, overflow: "hidden", flexShrink: 0, background: "#F2E4C8", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>
                          {l.images?.[0] ? <img src={l.images[0]} alt={l.nom} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : "🎯"}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: "#1C1008", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{l.nom}</div>
                          <div style={{ fontSize: 11, color: "#7A5A3A" }}>{l.type} · {l.ville} · {formatPrix(l.prix)}</div>
                        </div>
                        <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: l.disponible ? "rgba(61,107,46,0.10)" : "rgba(196,68,26,0.10)", color: l.disponible ? "#3D6B2E" : "#C4441A" }}>
                          {l.disponible ? "Dispo" : "Indispo"}
                        </span>
                      </div>
                    ))
                  }
                </div>

                {/* Réservations récentes */}
                <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                  <div style={{ padding: "18px 24px", borderBottom: "1.5px solid #E8DCC8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008", margin: 0 }}>Réservations récentes</h3>
                    <button onClick={() => setOnglet("reservations")} style={{ fontSize: 12, color: "#C4441A", fontWeight: 600, background: "none", border: "none", cursor: "pointer" }}>Voir tout →</button>
                  </div>
                  {reservations.length === 0
                    ? <div style={{ padding: 32, textAlign: "center", color: "#7A5A3A", fontSize: 13 }}>Aucune réservation pour le moment</div>
                    : reservations.slice(0, 4).map((r, i, arr) => (
                      <div key={r.id} style={{ padding: "13px 24px", borderBottom: i < arr.length - 1 ? "1px solid #F2E4C8" : "none" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 3 }}>
                          <span style={{ fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{r.nomClient} {r.prenomClient}</span>
                          <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 8px", borderRadius: 20, background: STATUT_RESA[r.statut]?.bg, color: STATUT_RESA[r.statut]?.color }}>{STATUT_RESA[r.statut]?.label}</span>
                        </div>
                        <div style={{ fontSize: 11, color: "#7A5A3A" }}>{r.Loisir?.nom || "Activité"} · {r.dateActivite} · {r.nbPersonnes} pers.</div>
                        <div style={{ fontSize: 12, fontWeight: 700, color: "#C4441A", marginTop: 3 }}>{formatPrix(r.total)}</div>
                      </div>
                    ))
                  }
                </div>
              </div>

              {resasAttente.length > 0 && (
                <div style={{ marginTop: 20, background: "rgba(196,132,26,0.06)", border: "1.5px solid rgba(196,132,26,0.25)", borderRadius: 12, padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: "#C4841A" }}>{resasAttente.length} réservation{resasAttente.length > 1 ? "s" : ""} en attente de confirmation</div>
                    <div style={{ fontSize: 12, color: "#7A5A3A" }}>Des clients attendent votre réponse.</div>
                  </div>
                  <button onClick={() => setOnglet("reservations")} className="btn-primary"
                    style={{ color: "white", borderRadius: 8, padding: "9px 18px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, whiteSpace: "nowrap" }}>
                    Voir →
                  </button>
                </div>
              )}
            </>
          )}

          {/* ══ MES ACTIVITÉS ══ */}
          {onglet === "activites" && (
            <>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24, flexWrap: "wrap", gap: 12 }}>
                <div>
                  <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Mes activités</h2>
                  <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>{loisirs.length} activité{loisirs.length !== 1 ? "s" : ""}</p>
                </div>
                <button className="btn-primary" onClick={() => { setShowForm(!showForm); setForm({ ...FORM_VIDE, telephoneContact: user.telephone || "" }); setPhotos([]); setEditId(null); }}
                  style={{ color: "white", borderRadius: 10, padding: "10px 20px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700 }}>
                  {showForm ? "Annuler" : "+ Ajouter une activité"}
                </button>
              </div>

              {showForm && !editId && (
                <FormulaireActivite
                  f={form} setF={setForm} ph={photos} setPh={setPhotos}
                  onSave={ajouterLoisir} onCancel={() => { setShowForm(false); setForm(FORM_VIDE); setPhotos([]); }}
                  saving={saving} titre="Nouvelle activité"
                  uploading={uploading} fileRef={fileRef} onPhotoChange={handlePhotos}
                />
              )}

              {editId && (
                <FormulaireActivite
                  f={editForm} setF={setEditForm} ph={editPhotos} setPh={setEditPhotos}
                  onSave={sauvegarderEdit} onCancel={() => setEditId(null)}
                  saving={editSaving} titre="Modifier l'activité"
                  uploading={uploading} fileRef={fileEditRef} onPhotoChange={handleEditPhotos}
                />
              )}

              {loisirs.length === 0 && !showForm ? (
                <div style={{ textAlign: "center", padding: 60, color: "#7A5A3A" }}>
                  <p style={{ fontSize: 15, marginBottom: 16 }}>Aucune activité enregistrée.</p>
                  <button className="btn-primary" onClick={() => setShowForm(true)} style={{ color: "white", borderRadius: 10, padding: "12px 24px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700 }}>
                    + Ajouter ma première activité
                  </button>
                </div>
              ) : (
                <div className="activites-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 16 }}>
                  {loisirs.map(l => (
                    <div key={l.id} style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden", boxShadow: "0 2px 12px rgba(28,16,8,0.06)" }}>
                      <div style={{ height: 140, background: "linear-gradient(135deg,#1C1008,#2D1A08)", overflow: "hidden", position: "relative" }}>
                        {l.images?.[0]
                          ? <img src={l.images[0]} alt={l.nom} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                          : <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 48, opacity: 0.5 }}>🎯</div>}
                        <span style={{ position: "absolute", top: 10, right: 10, fontSize: 11, fontWeight: 700, padding: "4px 10px", borderRadius: 20, background: l.disponible ? "rgba(61,107,46,0.85)" : "rgba(196,68,26,0.85)", color: "white" }}>
                          {l.disponible ? "Disponible" : "Indisponible"}
                        </span>
                        <span style={{ position: "absolute", top: 10, left: 10, fontSize: 11, fontWeight: 700, padding: "4px 10px", borderRadius: 20, background: "rgba(0,0,0,0.45)", color: "white" }}>
                          {l.type}
                        </span>
                      </div>
                      <div style={{ padding: 16 }}>
                        <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 15, fontWeight: 800, color: "#1C1008", margin: "0 0 4px" }}>{l.nom}</h3>
                        <div style={{ fontSize: 12, color: "#7A5A3A", marginBottom: 4 }}>{l.ville}{l.adresse ? ` · ${l.adresse}` : ""}</div>
                        {l.duree && <div style={{ fontSize: 11, color: "#7A5A3A", marginBottom: 10 }}>⏱ {l.duree}</div>}
                        {l.description && <p style={{ fontSize: 12, color: "#7A5A3A", lineHeight: 1.5, margin: "0 0 12px", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{l.description}</p>}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 12, borderTop: "1px solid #F2E4C8" }}>
                          <div>
                            <div style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#C4441A" }}>{formatPrix(l.prix)}</div>
                            <div style={{ fontSize: 11, color: "#7A5A3A" }}>par personne</div>
                          </div>
                          <div style={{ display: "flex", gap: 6 }}>
                            <button onClick={() => { ouvrirEdit(l); setShowForm(false); window.scrollTo(0, 0); }}
                              style={{ background: "rgba(196,68,26,0.08)", border: "none", borderRadius: 8, padding: "7px 10px", fontSize: 12, fontWeight: 600, color: "#C4441A", cursor: "pointer", display: "flex", alignItems: "center", gap: 4 }}>
                              <IcEdit /> Modifier
                            </button>
                            <button onClick={() => supprimerLoisir(l.id)}
                              style={{ background: "rgba(196,68,26,0.06)", border: "none", borderRadius: 8, padding: "7px 10px", fontSize: 12, fontWeight: 600, color: "#C4441A", cursor: "pointer", display: "flex", alignItems: "center", gap: 4 }}>
                              <IcTrash />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}

          {/* ══ RÉSERVATIONS ══ */}
          {onglet === "reservations" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Réservations</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>
                  {reservations.length} réservation{reservations.length !== 1 ? "s" : ""}
                  {resasAttente.length > 0 && <span style={{ color: "#C4841A", fontWeight: 700 }}> · {resasAttente.length} en attente</span>}
                </p>
              </div>

              <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
                {["tous", "en_attente", "confirmee", "annulee"].map(s => (
                  <button key={s} onClick={() => setFiltreStatut(s)}
                    style={{ padding: "7px 16px", borderRadius: 20, border: `1.5px solid ${filtreStatut === s ? "#C4441A" : "#E8DCC8"}`, background: filtreStatut === s ? "#C4441A" : "white", color: filtreStatut === s ? "white" : "#7A5A3A", fontSize: 13, fontWeight: 600, cursor: "pointer", transition: "all .2s" }}>
                    {s === "tous" ? "Toutes" : STATUT_RESA[s]?.label}
                  </button>
                ))}
              </div>

              {resasFiltrees.length === 0
                ? <div style={{ textAlign: "center", padding: 60, color: "#7A5A3A", fontSize: 14 }}>Aucune réservation</div>
                : (
                  <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                    {resasFiltrees.map(r => (
                      <div key={r.id} style={{ background: "white", borderRadius: 14, border: `1.5px solid ${r.statut === "en_attente" ? "rgba(196,132,26,0.35)" : "#E8DCC8"}`, padding: "20px 24px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
                              <span style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008" }}>{r.nomClient} {r.prenomClient}</span>
                              <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: STATUT_RESA[r.statut]?.bg, color: STATUT_RESA[r.statut]?.color }}>{STATUT_RESA[r.statut]?.label}</span>
                            </div>
                            <div style={{ fontSize: 13, color: "#7A5A3A", marginBottom: 4 }}>
                              🎯 {r.Loisir?.nom || "Activité"} · 📅 {r.dateActivite} · 👥 {r.nbPersonnes} personne{r.nbPersonnes > 1 ? "s" : ""}
                            </div>
                            <div style={{ display: "flex", gap: 16, fontSize: 12, color: "#7A5A3A" }}>
                              <span style={{ display: "flex", alignItems: "center", gap: 4 }}><IcPhone /> {r.telephoneClient}</span>
                              <span>✉️ {r.emailClient}</span>
                            </div>
                            {r.message && <div style={{ marginTop: 8, fontSize: 12, color: "#7A5A3A", background: "#FAF5EC", borderRadius: 8, padding: "8px 12px" }}>💬 {r.message}</div>}
                          </div>
                          <div style={{ textAlign: "right" }}>
                            <div style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 800, color: "#C4441A" }}>{formatPrix(r.total)}</div>
                            <div style={{ fontSize: 11, color: "#7A5A3A", marginBottom: 8 }}>{r.modePaiement}</div>
                            {r.statut === "en_attente" && (
                              <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                                <button className="btn-success" onClick={() => confirmerResa(r.id)}
                                  style={{ color: "white", borderRadius: 8, padding: "8px 14px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}>
                                  <IcCheck /> Confirmer
                                </button>
                                <button className="btn-primary" onClick={() => annulerResa(r.id)}
                                  style={{ color: "white", borderRadius: 8, padding: "8px 14px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}>
                                  <IcX /> Refuser
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )
              }
            </>
          )}

          {/* ══ HISTORIQUE ══ */}
          {onglet === "historique" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Historique & Revenus</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>{reservations.filter(r => r.statut === "confirmee").length} réservation{reservations.filter(r => r.statut === "confirmee").length !== 1 ? "s" : ""} confirmée{reservations.filter(r => r.statut === "confirmee").length !== 1 ? "s" : ""}</p>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 16, marginBottom: 24 }}>
                {[
                  { label: "Revenus confirmés",   value: totalRevenus.toLocaleString() + " F", color: "#3D6B2E" },
                  { label: "Visites confirmées",  value: reservations.filter(r => r.statut === "confirmee").length, color: "#C4441A" },
                  { label: "Visites annulées",    value: reservations.filter(r => r.statut === "annulee").length,   color: "#7A5A3A" },
                ].map((s, i) => (
                  <div key={i} style={{ background: "white", borderRadius: 14, padding: "22px", border: "1.5px solid #E8DCC8", textAlign: "center" }}>
                    <div style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: s.color }}>{s.value}</div>
                    <div style={{ fontSize: 12, color: "#7A5A3A", marginTop: 4, fontWeight: 600 }}>{s.label}</div>
                  </div>
                ))}
              </div>

              <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                {reservations.length === 0
                  ? <div style={{ padding: 40, textAlign: "center", color: "#7A5A3A", fontSize: 14 }}>Aucune réservation pour le moment</div>
                  : (
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr style={{ background: "#FAF5EC" }}>
                          {["Client", "Activité", "Date", "Personnes", "Total", "Statut"].map(h => (
                            <th key={h} style={{ padding: "12px 20px", fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: 1, textAlign: "left", borderBottom: "1.5px solid #E8DCC8" }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {reservations.map((r, i) => (
                          <tr key={r.id} className="row-hover" style={{ borderBottom: i < reservations.length - 1 ? "1px solid #F2E4C8" : "none" }}>
                            <td style={{ padding: "14px 20px", fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{r.nomClient} {r.prenomClient}</td>
                            <td style={{ padding: "14px 20px", fontSize: 13, color: "#7A5A3A" }}>{r.Loisir?.nom || "—"}</td>
                            <td style={{ padding: "14px 20px", fontSize: 12, color: "#7A5A3A" }}>{r.dateActivite}</td>
                            <td style={{ padding: "14px 20px", fontSize: 13, color: "#7A5A3A" }}>{r.nbPersonnes} pers.</td>
                            <td style={{ padding: "14px 20px", fontFamily: "'Fraunces',serif", fontSize: 15, fontWeight: 700, color: "#3D6B2E" }}>{formatPrix(r.total)}</td>
                            <td style={{ padding: "14px 20px" }}>
                              <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: STATUT_RESA[r.statut]?.bg, color: STATUT_RESA[r.statut]?.color }}>
                                {STATUT_RESA[r.statut]?.label}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )
                }
              </div>
            </>
          )}

          {/* ══ AVIS ══ */}
          {onglet === "avis" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Avis clients</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>
                  Note moyenne :{" "}
                  <strong>
                    {loisirs.length > 0
                      ? (loisirs.reduce((s, l) => s + (l.note || 0), 0) / loisirs.length).toFixed(1)
                      : "—"}/5
                  </strong>
                </p>
              </div>

              {loisirs.length === 0
                ? <div style={{ textAlign: "center", padding: 60, color: "#7A5A3A", fontSize: 14 }}>Ajoutez d'abord une activité pour recevoir des avis.</div>
                : (
                  <>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 16, marginBottom: 24 }}>
                      {loisirs.map(l => (
                        <div key={l.id} style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", padding: "20px 24px", textAlign: "center" }}>
                          <div style={{ fontFamily: "'Fraunces',serif", fontSize: 28, fontWeight: 800, color: "#C4441A" }}>{l.note?.toFixed(1) || "—"}</div>
                          <div style={{ margin: "6px 0" }}>
                            {[1,2,3,4,5].map(i => (
                              <span key={i} style={{ color: i <= Math.round(l.note || 0) ? "#C4441A" : "#E8DCC8", fontSize: 16 }}>★</span>
                            ))}
                          </div>
                          <div style={{ fontSize: 13, fontWeight: 600, color: "#1C1008", marginBottom: 2 }}>{l.nom}</div>
                          <div style={{ fontSize: 11, color: "#7A5A3A" }}>{l.avis || 0} avis</div>
                        </div>
                      ))}
                    </div>
                    <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", padding: "32px", textAlign: "center" }}>
                      <p style={{ fontSize: 13, color: "#7A5A3A", margin: 0 }}>Les avis détaillés seront affichés ici dès que des clients en laisseront.</p>
                    </div>
                  </>
                )
              }
            </>
          )}

        </div>
      </div>
      <Footer />
    </>
  );
}